import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { getGlobalObject } from "#/utils/get-global-object.utils";

// Log levels
export type LogLevel = "debug" | "info" | "warn" | "error";

// Context interface for logs
export interface LogContext {
  userId?: string;
  userEmail?: string;
  orgId?: string;
  componentName?: string;
  action?: string;
  [key: string]: any;
}

// Enhanced error logging with both RUM and Logs
export const logError = (
  error: Error,
  info: {
    componentStack?: string;
    errorId: string;
    email?: string;
    orgId?: string;
  },
) => {
  const RumGlobal = getGlobalObject<Window>().DD_RUM;

  // Log to RUM (for user sessions and replay)
  if (RumGlobal) {
    RumGlobal.addError(error, {
      scope: info?.componentStack,
      errorId: info.errorId,
      email: info.email,
      orgId: info.orgId,
    });
  }

  datadogLogs.logger.error(
    error.message,
    {
      errorId: info.errorId,
      errorStack: error.stack,
      componentStack: info.componentStack,
      email: info.email,
      orgId: info.orgId,
      errorName: error.name,
    },
    error,
  );
};

export const logger = {
  debug: (message: string, context?: LogContext) => {
    datadogLogs.logger.debug(message, context);
  },

  info: (message: string, context?: LogContext) => {
    datadogLogs.logger.info(message, context);
  },

  warn: (message: string, context?: LogContext) => {
    datadogLogs.logger.warn(message, context);
  },

  error: (message: string, context?: LogContext, error?: Error) => {
    datadogLogs.logger.error(message, context, error);
  },
};

export const setAccountContext = (account: {
  id: string;
  name?: string;
  type?: string;
  [key: string]: any;
}) => {
  datadogLogs.setAccount(account);
  // RUM too, so sessions, actions and errors carry `@account.id` (the org).
  datadogRum.setAccount(account);
};

export const clearAccountContext = () => {
  datadogLogs.clearAccount();
  datadogRum.clearAccount();
};
